import { render, staticRenderFns } from "./MatchBrowser.vue?vue&type=template&id=b6f45c82"
import script from "./MatchBrowser.vue?vue&type=script&lang=js"
export * from "./MatchBrowser.vue?vue&type=script&lang=js"
import style0 from "./MatchBrowser.vue?vue&type=style&index=0&id=b6f45c82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports